import { cargoes } from '../entities/cargoes-sidecar'
import { machines } from '../machines/machines-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { l } from '../lib/imports'
import { scene } from '../main/scene-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { createTask_moveTo } from './taskMoveTo'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'

export function createTask_placeInEmptySpace(i: number, j: number): ITask {
  return jobs._createTask(i, j, 'place-in-empty-space', {})
}

export function isSpotEmptyFloor(i: number, j: number) {
  let ctx = scene.getContext()
  if (cargoes.findAtSpot(i, j, (c) => true, true)) {
    return false
  }
  if (machines.findAtSpot(i, j, (c) => true)) {
    return false
  }
  let tile = tileMapShip.getTile(ctx.mapShip, i, j)
  if (!tile) {
    return false
  }
  if (!tile.dataFloor) {
    return false
  }
  let std = tilesDataShip.getStandard()
  if (tile.dataFloor !== std.floor) {
    return false
  }
  return true
}

export function runTask_placeInEmptySpace(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'place-in-empty-space')
  let m = jobLogger.assertReserved(job)

  if (jobLogger.runSubtasks(job, task)) {
    return
  }

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }

  if (isSpotEmptyFloor(m.i, m.j)) {
    // Nothing is here!
    monsters.dropCargo(m)
    return jobLogger.succeedTask(job, task)
  }

  let spread = 1 + task.counter
  if (spread > 50) {
    spread = 50
  }
  let i = l.random(-spread, spread, false) + m.i
  let j = l.random(-spread, spread, false) + m.j
  if (!isSpotEmptyFloor(i, j)) {
    task.counter++
    if (task.counter > 300) {
      jobLogger.failTask(
        job,
        task,
        'couldnt find spot to drop in reasonable time',
      )
    }
    return // try again later
  }

  task.subtasks.push(createTask_moveTo(i, j, true, false))
}
